import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const relatedOffersSlider = $('.section-hotel-hp-detail-booking .related-offers-slider .slider');
    if (relatedOffersSlider.length) {
      relatedOffersSlider.on('init', function() {
        helpers.equalHeightElements('.related-offers-slider .equal-height');
      });

      relatedOffersSlider.slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        appendArrows: '.related-offers-slider .slide-nav',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptEatDrink.js